export enum EventCategory {
  FLIGHT = 'flight',
  ANALYSIS = 'Analysis',
  NAVIGATION = 'Navigation',
}
